import { render, staticRenderFns } from "./reportadminmain.vue?vue&type=template&id=029ce623&scoped=true"
import script from "./reportadminmain.vue?vue&type=script&lang=js"
export * from "./reportadminmain.vue?vue&type=script&lang=js"
import style0 from "./reportadminmain.vue?vue&type=style&index=0&id=029ce623&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029ce623",
  null
  
)

export default component.exports